export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-8">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <p className="text-sm">
          © {new Date().getFullYear()} Ranjit · Frontend Developer
        </p>
        <p className="text-xs mt-2">
          Built with React & Tailwind CSS
        </p>
      </div>
    </footer>
  );
}
